import React from 'react';

import {
  storageGetItemDateRange,
  storageSetItemDateRange,
  fetchFieldServiceInfo,
} from '../utilities/dateSelectorUtility';
import { HeaderDateSelector } from './HeaderDateSelector';
import parts from '../utilities/parts';

export class GlobalHeaderDateSelector extends React.Component {
  constructor(props) {
    super(props);

    const { positionKey, noShowDateFlag } = props;

    const field_id = sessionStorage.getItem('field_id') || null;

    const { fromDate, toDate, workHourZone } = storageGetItemDateRange();

    this.state = {
      positionKey,
      noShowDateFlag,

      field_id,

      fromDate,
      toDate,
      workHourZone,

      workHourZoneDayVisible: false,
      workHourZoneNightVisible: false,
      workHourZoneMidnightVisible: false,
    };
    this.handleChangeSearchDateRange = this.handleChangeSearchDateRange.bind(
      this
    );
  }

  componentDidMount() {
    if (this.state.field_id) {
      (async () => {
        const workHourZoneParam = await fetchFieldServiceInfo(
          this.state.field_id,
          this.state.workHourZone
        );
        sessionStorage.setItem('work_hour_zone', workHourZoneParam.workHourZone);
        this.setState(workHourZoneParam);
      })();
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ noShowDateFlag: nextProps.noShowDateFlag });
  }

  /**
   * 変更ボタンクリック時のイベントハンドラ
   */
  handleChangeSearchDateRange({ fromDate, toDate, workHourZone }) {
    storageSetItemDateRange({
      fromDate,
      toDate,
      workHourZone,
    });

    // リロードするので必要ないのでコメントアウト
    // 後々リロードしなくても良いようにするなら必要かもしれないなので残しておく
    // this.setState({
    //   fromDate,
    //   toDate,
    //   workHourZone,
    // });

    document.location.reload();
  }

  render() {
    if (
      parts.inProperty(
        this.state,
        'positionKey,noShowDateFlag,field_id,' +
          'fromDate, toDate, workHourZone,' +
          'workHourZoneDayVisible, workHourZoneNightVisible, workHourZoneMidnightVisible'
      ) === false ||
      parts.propertyCount(this.state) !== 9
    ) {
      throw new Error('GlobalHeaderDateSelector.jsx render');
    }
    // console.log('GlobalHeaderDateSelector.jsx render', this.state);

    const {
      positionKey,
      noShowDateFlag,
      field_id,
      fromDate,
      toDate,
      workHourZone,
      workHourZoneDayVisible,
      workHourZoneNightVisible,
      workHourZoneMidnightVisible,
    } = this.state;

    return (
      <HeaderDateSelector
        {...{
          positionKey,
          noShowDateFlag,
          field_id,
          fromDate,
          toDate,
          workHourZone,
          workHourZoneDayVisible,
          workHourZoneNightVisible,
          workHourZoneMidnightVisible,
          handleChangeSearchDateRange: this.handleChangeSearchDateRange,
        }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/GlobalHeaderDateSelector.jsx